import { Component } from '@angular/core';

@Component({
  selector: 'fgb-brand-page',
  templateUrl: './brand-page.component.html',
  styleUrls: ['./brand-page.component.scss'],
})
export class BrandPageComponent {}
